import BulletSection from './bullet-section';

export default BulletSection;
